export function navigation() {
    const doc = document.getElementsByTagName('html')[0];
    const navBtn = document.getElementById('mainNav');
    const navItems = document.getElementById('navItems');
    const brandName = document.querySelector('div.navbar-header a.navbar-brand');

    navBtn.addEventListener('click', function () {
        if (navBtn.classList.contains('active')) {
            navBtn.classList.remove('active');
            navItems.classList.remove('active');
            brandName.classList.remove('active');
            doc.classList.remove('no-scroll');
        } else {
            navBtn.classList.add('active');
            navItems.classList.add('active');
            brandName.classList.add('active');
            doc.classList.add('no-scroll');
        }
    });
}
